import { call, fork, takeLatest } from 'redux-saga/effects';

import { loadTeamTopTalents as loadTeamTopTalentsAPI } from '../api';
import { teamsTopTalentsListActions } from './actions';

export function* loadTeamTopTalents({payload}) {
    const { teamId } = payload;
    yield call(loadTeamTopTalentsAPI, teamId);
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadTeamTopTalents() {
  yield takeLatest(teamsTopTalentsListActions.LOAD_TEAM_TOP_TALENTS, loadTeamTopTalents);
}

//=====================================
//  ROOT
//-------------------------------------

export const teamsTopTalentsSagas = [
    fork(watchLoadTeamTopTalents),
];
